import {useParams} from 'react-router-dom'
import {appsAPI} from '../../../services/AppsService'
import {KTSVG} from '../../../template/helpers'
import {LinesAmoCRM} from './crm/amocrm/lines/LinesAmoCRM'
import {OutgoingCall} from './crm/amocrm/OutgoingCall'
import {LinesBitrix} from './crm/bitrix24/lines/LinesBitrix'
import {useIntl} from 'react-intl'

const AppLines = () => {
  const intl = useIntl()
  const {appId} = useParams()
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)

  return (
    <>
      {app?.crm === 'AMOCRM' && <OutgoingCall />}
      <div className='card card-custom card-stretch shadow-sm mb-5'>
        <div className='card-header'>
          <div className='d-flex flex-stack col-12 mt-5 me-10'>
            <div className='card-title m-0 d-flex flex-wrap'>
              <h3 className='fw-bolder m-0'>{intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.INCOMING'})}</h3>
            </div>
            <div className='text-align-end align-self-center d-flex'>
              <button className='btn btn-sm btn-primary' data-bs-toggle='modal' data-bs-target='#kt_modal_1'>
                <>
                  <KTSVG path='/media/icons/duotune/arrows/arr009.svg' className='svg-icon-muted svg-icon-1x' />
                  {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.INCOMING.ADDLINE'})}
                </>
              </button>
            </div>
          </div>

          {app?.crm === 'AMOCRM' && (
            <div className='text-align-start row mb-5 mt-5 fs-8'>
              <div className='col-lg-12'>
                <span className='small text-uppercase fw-bolder text-gray-600'>U/C/CL</span>
                <span className='small text-gray-600'>
                  - {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.MODE.DESCRIPTION'})}
                </span>
              </div>
            </div>
          )}
          {app?.crm === 'BITRIX24' && (
            <div className='text-align-start row mb-5 mt-5 fs-8'>
              <div className='col-lg-12'>
                <span className='small fw-bolder text-gray-600'>
                  {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.MANAGER.TIME'})}
                </span>
                <span className='small text-gray-600'>
                  {' '}
                  - {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.MANAGER.TIME.DESCRIPTION'})}
                </span>
              </div>
            </div>
          )}
        </div>
        <div className='card-body px-0'>
          <div className='table-responsive'>
            {app?.crm === 'AMOCRM' && <LinesAmoCRM />}
            {app?.crm === 'BITRIX24' && <LinesBitrix />}
          </div>
        </div>
      </div>
    </>
  )
}

export {AppLines}
